module.exports = import("https://www.gstatic.com/firebasejs/12.1.0/firebase-firestore.js");;